import CustomFormControl from "features/bidding-center/Dropdown/CustomFormControl";
import "./AttributionSettings.scss";
import { MenuItem } from "@mui/material";
import {
  ClickThroughAttributionOptions,
  ViewThroughAttributionOptions,
} from "features/meta-travel-ads-campaign/constants/attributionSettingsOptions";

const AttributionSettings = ({
  clickThroughValue,
  setClickThroughValue,
  viewThroughValue,
  setViewThroughValue,
}) => {
  return (
    <div className="multi-ads">
      <span className="section-title">ATTRIBUTION SETTINGS</span>
      <div className="dropdown-wrapper">
        <CustomFormControl
          minWidth={"360px"}
          displayEmpty
          disabled
          value={clickThroughValue}
          onChange={(e) => setClickThroughValue(e.target.value)}
          renderValue={(selected) => {
            if (!selected) {
              return (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#bab7b7",
                  }}
                >
                  Click through
                </span>
              );
            }
            return ClickThroughAttributionOptions[selected];
          }}
          required
          helperText={"Click through"}
          helperTextFontSize={"10px"}
          sx={{
            '& > span': { color: '#9e9e9e !important' },
            '& .MuiSelect-select': {
              backgroundColor: '#f5f5f5',
              WebkitTextFillColor: '#9e9e9e !important',
            },
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#f5f5f5',
            },
          }}
          paperProps={{
            style: {
              borderRadius: "10px",
            },
          }}
        >
          {Object.entries(ClickThroughAttributionOptions).map(
            ([key, value]) => (
              <MenuItem key={key} value={key}>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#373F41",
                    marginLeft: "4px",
                  }}
                >
                  {value}
                </span>
              </MenuItem>
            ),
          )}
        </CustomFormControl>
        <CustomFormControl
          minWidth={"360px"}
          displayEmpty
          disabled
          value={viewThroughValue}
          onChange={(e) => setViewThroughValue(e.target.value)}
          renderValue={(selected) => {
            if (selected === undefined || selected === null) {
              return (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#bab7b7",
                  }}
                >
                  View through
                </span>
              );
            }
            return ViewThroughAttributionOptions[selected];
          }}
          required
          helperText={"View through"}
          helperTextFontSize={"10px"}
          sx={{
            '& > span': { color: '#9e9e9e !important' },
            '& .MuiSelect-select': {
              backgroundColor: '#f5f5f5',
              WebkitTextFillColor: '#9e9e9e !important',
            },
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#f5f5f5',
            },
          }}
          paperProps={{
            style: {
              borderRadius: "10px",
            },
          }}
          success={!(viewThroughValue === undefined || viewThroughValue === null)}
        >
          {Object.entries(ViewThroughAttributionOptions).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              <span
                style={{
                  fontSize: "12px",
                  color: "#373F41",
                  marginLeft: "4px",
                }}
              >
                {value}
              </span>
            </MenuItem>
          ))}
        </CustomFormControl>
      </div>
    </div>
  );
};

export default AttributionSettings;
